import { BrowserRouter, Navigate, Route, Routes } from 'react-router';

import {
  LoginErrorPage,
  LoginPage,
  LoginTOTPPage,
  LogoutPage,
  PasswordResetPage,
  RequestResetPasswordPage,
  SignupPage,
} from './components/AuthPages';
import BlogArticlePage from './components/BlogArticles';
import CareersPage from './components/Careers';
import CheckoutPage from './components/CheckoutPage';
import CompanyPage from './components/CompanyPage';
import DataPage from './components/DataPage';
import IntegrationsPage from './components/IntegrationsPage';
import HomePage from './components/HomePage';
import Layout from './components/Layout';
import { PrivacyPolicyPage, TermsOfUsePage } from './components/LegalPages';
import NotFoundPage from './components/NotFoundPage';
import Notices from './components/Notices';
import { PricingPage } from './components/PricingPage';
import { products } from './components/ProductPages';
import ProfilePage from './components/ProfilePage';
import ScrollToTop from './components/ScrollToTop';
import SpinGiverPage from './components/SpinGiverPage';
import VerifyEmailPage from './components/VerifyEmailPage';
import ActivateEarlyTrialModalHost from '@cartwhl/ui/modals/ActivateEarlyTrialModalHost';
import PurchaseCreditsModalHost from '@cartwhl/ui/modals/PurchaseCreditsModalHost';

import { ModalManager } from './modals';

function AppContent() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Notices />
      <ModalManager />
      <PurchaseCreditsModalHost />
      <ActivateEarlyTrialModalHost />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/data" element={<DataPage />} />
          <Route path="/plugins" element={<IntegrationsPage />} />
          <Route
            path="/integrations"
            element={<Navigate to="/plugins" replace />}
          />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/pricing/:tab" element={<PricingPage />} />
          <Route path="/canvas-pricing" element={<Navigate to="/pricing" replace />} />
          <Route path="/api-pricing" element={<Navigate to="/pricing" replace />} />
          <Route path="/company" element={<CompanyPage />} />
          <Route path="/careers/:slug" element={<CareersPage />} />
          <Route path="/blog/:slug" element={<BlogArticlePage />} />
          {products.map((product) => (
            <Route
              key={product.slug}
              path={`/product/${product.slug}`}
              element={product.page}
            />
          ))}
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-use" element={<TermsOfUsePage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/profile/:tab" element={<ProfilePage />} />
          <Route path="/spin-giver" element={<SpinGiverPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
        {/* Auth pages (no header/footer) */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/sign-up" element={<SignupPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/password-reset" element={<PasswordResetPage />} />
        <Route
          path="/request-password-reset"
          element={<RequestResetPasswordPage />}
        />
        <Route path="/login-totp" element={<LoginTOTPPage />} />
        <Route path="/login-error" element={<LoginErrorPage />} />
        <Route path="/logout" element={<LogoutPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default function App() {
  return <AppContent />;
}
